<template>
  <div class="filter-bar" :class="visible && 'visible'">
    <TransitionCollapse :time="transitionDuration">
      <div v-if="visible" class="filter-bar__wrapper wrapper">
        <div class="filter-bar__wrapper-inner container">
          <p>Filtrar por:</p>
          <div class="filter-bar__filters">
            <!-- clients -->
            <AppMultiselect
              v-model="filters.account"
              class="account"
              :options="filterbarConfig.account.options"
              :placeholder="filters.account || filterbarConfig.account.placeholder"
              @input="updateFilters"
              @remove="unsetPackFilter"
            />
            <!-- user -->
            <AppMultiselect
              v-model="filters.user"
              class="user"
              :options="filterbarConfig.user.options"
              :placeholder="filters.user || filterbarConfig.user.placeholder"
              @input="updateFilters"
            />
            <!-- category -->
            <AppMultiselect
              v-model="filters.category"
              class="category"
              :options="filterbarConfig.category.options"
              :placeholder="filters.category || filterbarConfig.category.placeholder"
              @input="updateFilters"
            />
            <!-- packs -->
            <AppMultiselect
              v-model="filters.status"
              @input="updateFilters"
              class="status"
              :options="filterbarConfig.status.options"
              :placeholder="filters.status || filterbarConfig.status.placeholder"
            />
            <!-- packs
            <AppMultiselect
              v-model="filters.pack"
              @input="updateFilters"
              :class="filters.pack && 'pack-selected'"
              :options="filterbarConfig.pack.options"
              :placeholder="filters.pack || filterbarConfig.pack.placeholder"
              :disabled="filters.account !== null"
            /> -->
            <AppButton ripple @click="clearFilters">Limpiar</AppButton>
          </div>
        </div>
      </div>
    </TransitionCollapse>
    <div v-if="isMobile" class="filter-bar__menu-toggle">
      <AppIcon :icon="filterMenuIcon" @click="toggleTransitionCollapse" />
    </div>
  </div>
</template>

<script>
// Utilities
import filterbarConfig from 'Utils/config/filterBar'
import TransitionCollapse from 'Mixins/TransitionCollapse'
// Components
import AppIcon from 'Ui/AppIcon'
import AppButton from 'Ui/AppButton'
import AppMultiselect from 'Ui/AppMultiselect'

export default {
  name: 'FilterBar',

  components: {
    AppIcon,
    AppButton,
    AppMultiselect,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    transitionDuration: {
      type: Number,
      default: 600,
    },
  },

  mixins: [TransitionCollapse],

  data() {
    return {
      filters: {
        account: null,
        user: null,
        category: null,
        pack: null,
        status: null,
      },
      filterbarConfig,
      filteredItems: this.items,
      visible: false,
      isMobile: false,
    }
  },

  methods: {
    multiFilter() {
      const filterKeys = Object.keys(this.filters)
      // filtering items
      this.filteredItems = this.items.filter((item) => {
        return filterKeys.every((key) => {
          if (!this.filters[key]) return true
          switch (key) {
            case 'account':
              if (item[key].name === this.filters[key]) this.setPackFilter(item[key].pack_name)
              return item[key].name === this.filters[key]
            case 'user':
              if (this.filters[key] === 'sin asignar') {
                if (!item['users'].some((user) => user.type === 'EMPLOYEE')) return item
              } else {
                return item['users'].find((user) => user.username === this.filters[key])
              }
              break
            case 'category':
              return item[key] === this.filters[key]
            case 'pack':
              return item['account'].pack_name === this.filters[key]
            case 'status':
              return item['status'] === this.filters[key]
          }
        })
      })
    },

    setPackFilter(packName) {
      this.filters.pack = packName
    },

    unsetPackFilter() {
      this.filters.pack = null
    },

    updateFilters() {
      this.multiFilter()
      this.$emit('updated-filters', this.filteredItems)
    },

    clearFilters() {
      const filtersKeys = Object.keys(this.filters)

      for (const key of filtersKeys) {
        this.filters[key] = null
      }
      this.updateFilters()
    },

    toggleIsMobile(screenWidth) {
      if (screenWidth > 680) {
        this.isMobile = false
        this.visible = true
      }
      if (screenWidth < 680) {
        this.isMobile = true
        this.visible = false
      }
    },

    resizeFunction() {
      this.toggleIsMobile(window.innerWidth)
    },
  },

  computed: {
    filterMenuIcon() {
      return this.visible ? 'far fa-times' : 'far fa-sliders-h'
    },
  },

  watch: {
    items(newValue) {
      newValue && this.updateFilters()
    },
  },

  mounted() {
    this.updateFilters()
    this.resizeFunction()
    window.addEventListener('resize', this.resizeFunction)
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeFunction)
  },
}
</script>

<style scoped>
.filter-bar {
  background-color: var(--c-secondary-300);
}

.filter-bar__wrapper-inner {
  display: flex;
  align-items: center;
  padding: 10px 30px;
  margin: 0 auto;
}

.filter-bar__filters {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 10px;
}

/* .filter-bar__filters >>> .multiselect:not(.account):not(.user) .multiselect__input {
  text-transform: capitalize;
} */

.filter-bar__wrapper-inner p {
  font-size: 14px;
  letter-spacing: 0.5px;
  margin: 0;
  white-space: nowrap;
  margin-right: 10px;
}

.filter-bar__filters >>> .multiselect.status .multiselect__input,
.filter-bar__wrapper-inner >>> .multiselect:not(.user) .multiselect__option span,
.filter-bar__wrapper-inner >>> .multiselect:not(.user) .multiselect__single {
  text-transform: capitalize;
}

.filter-bar__menu-toggle {
  position: relative;
  padding: 0 30px;
  text-align: right;
}

.filter-bar .app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  font-size: 22px;
  width: 42px;
  height: 42px;
  top: 10px;
  right: 30px;
  border-radius: 50px;
  color: #fff;
  background-color: var(--c-magenta-500);
  box-shadow: var(--box-shadow-floating-button);
  cursor: pointer;
}

@media (max-width: 1011px) {
  .filter-bar__wrapper-inner {
    flex-wrap: wrap;
  }

  .filter-bar__filters {
    margin-top: 15px;
  }
}

@media (max-width: 680px) {
  .filter-bar {
    background-color: transparent;
    transition: 2.5s ease;
  }

  .filter-bar.visible {
    background-color: var(--c-secondary-200);
    box-shadow: 0 0 15px -3px rgb(0 0 0 / 60%);
    transition: 0.1s ease;
  }

  .filter-bar__wrapper-inner {
    padding-bottom: 30px;
  }

  .filter-bar__filters {
    grid-template-columns: 1fr;
  }
}
</style>
